import Image from 'next/image'
import { DEFAULT_BANNER_URL } from '@/constants/stackup'

const AppBanner = () => (
  <div className="relative h-auto lg:h-72">
    <Image
      src={DEFAULT_BANNER_URL}
      fill
      className="hidden lg:flex w-full h-auto"
      alt="Hackthon"
    />
    <div className="flex lg:hidden w-full h-48 bg-gray-900" />
    <div className="absolute inset-0 flex flex-col items-center lg:items-start justify-center p-8 lg:p-24 w-full lg:w-2/3">
      <h1 className="text-4xl lg:text-7xl font-semibold tracking-tight text-white leading-none mb-6">
        Hackathons
      </h1>
      <span className="font-normal lg:font-semibold text-center lg:text-left text-lg lg:text-xl text-white">
        Your stop to the world&apos;s most exciting and revolutionary
        hackathons. Join the rebellion. 🚀
      </span>
    </div>
  </div>
)
export default AppBanner
